export default __webpack_public_path__ + "static/media/la pantera rosa.5558900e.jpg";